// Imports de imágenes
import anaImg from 'assets/img/hvas/ana.png';
import sofiaImg from 'assets/img/hvas/sofia.png';
import margaretImg from 'assets/img/hvas/margaret.png';
import mirandaImg from 'assets/img/hvas/miranda.png';
import carmenImg from 'assets/img/hvas/carmen.png';
import ioannaImg from 'assets/img/hvas/ioanna.png';
import ioanna2Img from 'assets/img/hvas/ioanna2.png';
import ioanna3Img from 'assets/img/hvas/ioanna3.png';
import hannahImg from 'assets/img/hvas/hannah.png';
import julliaImg from 'assets/img/hvas/jullia.png';
import mariaImg from 'assets/img/hvas/maria.png';
import martinaImg from 'assets/img/hvas/martina.png';
import dilaraImg from 'assets/img/hvas/dilara.png';
import juliaImg from 'assets/img/hvas/julia.png';
import isabellaImg from 'assets/img/hvas/isabella.png';
import victoriaImg from 'assets/img/hvas/victoria.png';
import albertoImg from 'assets/img/hvas/alberto.png';
import salvadorImg from 'assets/img/hvas/salvador.png';
import eugeniosImg from 'assets/img/hvas/eugenios.png';
import annaImg from 'assets/img/hvas/anna.png';
import maria2Img from 'assets/img/hvas/maria2.png';
import victorImg from 'assets/img/hvas/victor.png';
import micaelaImg from 'assets/img/hvas/micaela.png';
import evaImg from 'assets/img/hvas/eva.png';
import valentinaImg from 'assets/img/hvas/valentina.png';

// Imports de audio
import anaAudio from 'assets/img/hvas/ana.mp3';
import sofiaAudio from 'assets/img/hvas/sofia.mp3';
import margaretAudio from 'assets/img/hvas/margaret.mp3';
import mirandaAudio from 'assets/img/hvas/miranda.mp3';
import carmenAudio from 'assets/img/hvas/carmen.mp3';
import ioannaAudio from 'assets/img/hvas/ioanna.mp3';
import hannahAudio from 'assets/img/hvas/hannah.mp3';
import julliaAudio from 'assets/img/hvas/jullia.mp3';
import mariaAudio from 'assets/img/hvas/maria.mp3';
import martinaAudio from 'assets/img/hvas/martina.mp3';
import dilaraAudio from 'assets/img/hvas/dilara.mp3';
import juliaAudio from 'assets/img/hvas/julia.mp3';
import isabellaAudio from 'assets/img/hvas/isabella.mp3';
import victoriaAudio from 'assets/img/hvas/victoria.mp3';
import albertoAudio from 'assets/img/hvas/alberto.mp3';
import salvadorAudio from 'assets/img/hvas/salvador.mp3';
import eugeniosAudio from 'assets/img/hvas/eugenios.mp3';
import annaAudio from 'assets/img/hvas/anna.mp3';
import maria2Audio from 'assets/img/hvas/maria2.mp3';
import victorAudio from 'assets/img/hvas/victor.mp3';
import micaelaAudio from 'assets/img/hvas/micaela.mp3';
import noAudio from 'assets/img/hvas/noaudio.mp3';
import valentinaAudio from 'assets/img/hvas/valentina.mp3';

export const hvaImagesandVoices: {
  [key: string]: { image: string; audio: string };
} = {
  ana: {
    image: anaImg,
    audio: anaAudio
  },
  sofia: {
    image: sofiaImg,
    audio: sofiaAudio
  },
  margaret: {
    image: margaretImg,
    audio: margaretAudio
  },
  miranda: {
    image: mirandaImg,
    audio: mirandaAudio
  },
  carmen: {
    image: carmenImg,
    audio: carmenAudio
  },
  ioanna: {
    image: ioannaImg,
    audio: ioannaAudio
  },
  ioanna2: {
    image: ioanna2Img,
    audio: ioannaAudio
  },
  ioanna3: {
    image: ioanna3Img,
    audio: ioannaAudio
  },
  hannah: {
    image: hannahImg,
    audio: hannahAudio
  },
  jullia: {
    image: julliaImg,
    audio: julliaAudio
  },
  maria: {
    image: mariaImg,
    audio: mariaAudio
  },
  martina: {
    image: martinaImg,
    audio: martinaAudio
  },
  dilara: {
    image: dilaraImg,
    audio: dilaraAudio
  },
  julia: {
    image: juliaImg,
    audio: juliaAudio
  },
  isabella: {
    image: isabellaImg,
    audio: isabellaAudio
  },
  victoria: {
    image: victoriaImg,
    audio: victoriaAudio
  },
  alberto: {
    image: albertoImg,
    audio: albertoAudio
  },
  salvador: {
    image: salvadorImg,
    audio: salvadorAudio
  },
  eugenios: {
    image: eugeniosImg,
    audio: eugeniosAudio
  },
  anna: {
    image: annaImg,
    audio: annaAudio
  },
  maria2: {
    image: maria2Img,
    audio: maria2Audio
  },
  victor: {
    image: victorImg,
    audio: victorAudio
  },
  micaela: {
    image: micaelaImg,
    audio: micaelaAudio
  },
  eva: {
    image: evaImg,
    audio: noAudio
  },
  valentina: {
    image: valentinaImg,
    audio: valentinaAudio
  }
};
